import axios from './axiosInstance';

// //Crew Create
// export const createCrew = (data) => {
//   return axios.post('/crew', data);
// };

//Update Crew
// Add updateCrew for updating crew by ID
export const updateCrew = (id, data) => {
  return axios.put(`/crew/${id}`, data);
};

//Crew Assign
// export const createCrewAssign = (data) => {
//   return axios.post('/crew/assign', data);
// };

// //Get Crew All
// export const getCrewAll = () => {
//   return axios.get('/crewAll');
// };

//Get Crew Filter
export const getCrewAllFilter = (filters) => {
  return axios.post('/crewAllFilter', filters);
};

//Get Employee Filter
export const getEmployeeAllFilter = (filters) => {
  return axios.post('/employeeAllFilter', filters);
};

// Schedule Workmen (no id param, just data)
export const CrewScheduleWorkmen = (data) => {
  return axios.post(`/scheduleWorkmen`, data);
};

//Get Labour Categories
export const getLabourCategories = () => {
  return axios.get('/labour-categories');
};

//Delete Schedule Workmen
export const deleteScheduleWorkmen = (data) => {
  return axios.post('/deleteScheduleWorkmen', data);
};

//Replace Schedule Workmen
export const replaceScheduleWorkmen = (data) => {
  return axios.post('/replaceScheduleWorkmen', data);
};

//Get Work Rule
export const getWorkRule = () => {
  return axios.get('/getWorkrule');
};

//Update Passes for Crew
export const updatePasses = (id, data) => {
  return axios.put(`/updatePasses/${id}`, data);
};



// export const deleteCrew = (id) => {
//   return axios.delete(`/crew`, { params: { id } });
// };

export const deleteCrew = (payload) => {
  return axios.delete("/crew", {
    data: payload,   // ✅ body goes here
  });
};




//Crew Refractoring Management APIs
export const createCrew = (data) => {
  return axios.post('/crew', data);
};
export const scheduleOverride = (data) => {
  return axios.post('/schedule/override', [data]);
};
//Get Crew All
export const getCrewAll = (filters) => {
  return axios.get('/crew', { params: filters });
};
// Get Particular Crew By Id
export const getCrew = (id, includeSchedule) => {
  return axios.get(`/crew/${id}`, {
    params: { includeSchedule }
  });
};

//Get Employee List
export const getEmployeeList = (data) => {
  return axios.post('/employee', data);
};
//Update Crew And Employee Details
export const updateCrewAndEmployeeDetails = (data) => {
  return axios.put('/crew', data);
};

//Add/Remove Employees from Crew
export const AddRemoveEmployees = (data) => {
  return axios.put('/employee-list', data);
};

//Assign Employees to Crew
export const assignEmployeesToCrew = (data) => {
  return axios.post('/crew/assign', data);
};

//Unassign Employees from Crew
export const unassignEmployeesFromCrew = (data) => {
  return axios.post('/crew/unassign', data);
};

export const fieldAutoSuggest = (payload) => {
  return axios.get('/autosuggest/crew', { params: payload });
};


// Crew Template APIs

// Create crew template
export const createCrewTemplate = (data) => {
  return axios.post('/crew-template', data);
};

// Get crew template list
export const getCrewTemplateList = (params) => {
  return axios.get('/crew-template', { params });
};

// Get crew template by ID
export const getCrewTemplateDetails = (id) => {
  return axios.get(`/crew-template/${id}`);
};

// Update crew template details
export const updateCrewTemplate = (data) => {
  return axios.put('/crew-template', data);
};

// Delete crew template
// export const deleteCrewTemplate = (id) => {
//   return axios.delete(`/crew-template/${id}`);
// };

export const deleteCrewTemplate = (payload) => {
  return axios.delete("/crew-template", {
    data: payload,   // ✅ body goes here
  });
};

// Auto-suggest crew template
export const autoSuggestCrew = (params) => {
  return axios.get('/autosuggest/crew', { params });
};

//Get Crew Transfer Owner
export const getCrewUser = (filters) => {
  return axios.get('/user', { params: filters });
};

//Fetch Employee hyperfind
export const fetchEmployeeHyperfind = () => {
  return axios.get('/user/employee-hyperfinds');
};

//Copy Crews
export const copyCrews = (data) => {
  return axios.post('/crew/copy', data);
};

//refresh employees, labour categories and FLS Crew from FLS manually
export const refreshData = (data) => {
  return axios.put('/user/refresh', data);
}

// AI Crew Builder (Crew Call) endpoints
export const analyzeCrewCall = (data) => axios.post('/crew-call/analyze', data);
export const clarifyCrewCall = (data) => axios.post('/crew-call/clarify', data);
export const executeCrewCall = (data) => axios.post('/crew-call/execute', data);
export const getCrewCallConfig = () => axios.get('/crew-call/config');
